__turbopack_context__.v({
  "container": "QzEvLG_container",
  "element": "QzEvLG_element",
});
